
interface Array<T> {
    flatMap<T, U>(callbackfn: (value: T, index: number, array: T[]) => U[]): U[];
}

(<any>Array.prototype).flatMap = function <T, U>(callbackfn: (value: T, index: number, array: T[]) => U[]): U[] {
    return [].concat(...this.map(callbackfn));
}